/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2017
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../utils/ShapingUIUtils'
], function(Class, ShapingUIUtils) {
	'use strict';

	var GlobalCalculationAction = Class.extend({

		/**
		 * Determine when we show/hide the menu item
		 */
		isItemVisible: function() {
			return true;
		},

		/**
		 * Default action handler
		 */
		onSelectItem: function(options) {
			options.target.activeObject.dataSource.getModule().then(function(module) {
				ShapingUIUtils.renderCalculationDialog(module);
			});
		}
	});

	return GlobalCalculationAction;
});
